<template>
    <div>
        <form class="login-form" @submit="login">

            <template v-if="!twoFactor && !secureKey">
                <h1>Log In</h1>
                <h1 class="loginWelcome">Welcome back, sign in below using your credentials.</h1>
                <div class="form-group">
                    <label for="Email">Email </label>
                    <input tabindex="0" aria-describedby="form_email_required form_email_regex" autocomplete="email" autofocus class="form-control" id="Email" name="Email" placeholder="Email" type="email" ref="email" @input="singleValid('email')" v-model="form.email.value" />
                    <span ref="emailRequiredValMsg" id="form_email_required" role="alert" aria-live="polite" class="text-danger" v-show="form.email.showError && form.email.errorType == 'required'"></span>
                    <span ref="emailRegexValMsg" id="form_email_regex" role="alert" aria-live="polite" class="text-danger" v-show="form.email.showError && form.email.errorType == 'regex'"></span>
                </div>
                <div class="form-group" v-if="!sso">
                    <label for="Password">Password </label>
                    <input tabindex="0" aria-describedby="form_password" autocomplete="current-password" class="form-control" data-val="true" id="Password" name="Password" placeholder="Password" type="password" ref="password" @input="singleValid('password')" v-model="form.password.value" />
                    <span ref="passwordRequiredValMsg" id="form_password" role="alert" aria-live="polite" class="text-danger" v-show="form.password.showError && form.password.errorType == 'required'"></span>
                </div>
                <div id="reCaptcha"></div>
                <div class="linkx-box" v-if="!sso">
                    <div class="checkbox">
                        <label>
                            <input id="RememberMe" name="RememberMe" type="checkbox" v-model="form.rememberme.value" />
                            Remember Me
                        </label>
                    </div>
                    <div class="forgot">
                        <a class="forgot" href="/account/forgotpassword/">Forgot password?</a>
                    </div>
                </div>
                <button class="btn login-btn" :disabled="loader || !form.valid">
                    <template v-if="!loader">
                        Log in
                    </template>
                    <template v-else>
                        <span class="spinner"></span>
                    </template>
                </button>
                <template v-if="autoSso === 'true'">
                    <a class="forgot identityProvider" href="/account/signin?autoSso=true">Sign in via your Identity Provider</a>
                </template>
                <template v-else>
                    <a class="forgot identityProvider" href="javascript:;" @click.prevent="sso = !sso">
                        <template v-if="!sso">
                            Sign in via your Identity Provider
                        </template>
                        <template v-else>
                            I want to use password sign-in
                        </template>
                    </a>
                </template>
            </template>

            <template v-if="twoFactor">
                <h1>Two-Factor Authentication</h1>
                <div class="form-group">
                    <label for="AutenticationCode"></label>
                    <input autocomplete="off" ref="authCode" class="form-control" id="AutenticationCode" name="AutenticationCode" :placeholder="twoFactorRecovery ? 'Recovery Code': 'Authentication Code'" type="text" @input="singleValid('autenticationCode')" v-model="form.autenticationCode.value" :maxlength="twoFactorRecovery ? 24 : 6" />
                    <span class="text-danger" v-if="form.autenticationCode.showError">Incorrect authentication code. <br> Please make sure your authenticator device is set to the correct time.</span>
                </div>
                <div class="signin-buttons">
                    <div class="left">
                        <a class="forgot" href="javascript:;" @click.prevent="twoFactorRecovery = !twoFactorRecovery">
                            <template v-if="twoFactorRecovery">
                                Enter the authentication code.
                            </template>
                            <template v-else>
                                Can't access your phone?
                            </template>
                        </a>
                    </div>
                    <div class="right">
                        <button class="btn login-btn" :disabled="loader || !form.valid">
                            <template v-if="!loader">
                                Sign in
                            </template>
                            <template v-else>
                                <span class="spinner"></span>
                            </template>
                        </button>
                    </div>
                </div>
            </template>

            <template v-if="secureKey">
                <img :src="'/Content/images/U2F-Image.png'" class="secure-key-image" alt="secure key" />
                <p class="text-danger text-center">Please insert your U2F security key.<br> If exists tap to security key button.</p>
            </template>
        </form>
    </div>
</template>
<script>
    import Services from "js/settings/_axios";
    import Notification from "js/settings/_notification";

    import "js/vendors/u2fApi";

    function coerceToArrayBuffer(input) {
        if (typeof input === "string") {
            // base64url to base64
            input = input.replace(/-/g, "+").replace(/_/g, "/");

            // base64 to Uint8Array
            var str = window.atob(input);
            var bytes = new Uint8Array(str.length);
            for (var i = 0; i < str.length; i++) {
                bytes[i] = str.charCodeAt(i);
            }
            input = bytes;
        }

        // Array to Uint8Array
        if (Array.isArray(input)) {
            input = new Uint8Array(input);
        }

        // Uint8Array to ArrayBuffer
        if (input instanceof Uint8Array) {
            input = input.buffer;
        }

        // error if none of the above worked
        if (!(input instanceof ArrayBuffer)) {
            throw new TypeError("could not coerce '" + name + "' to ArrayBuffer");
        }

        return input;
    }
    function coerceToBase64Url(input) {
        // Array or ArrayBuffer to Uint8Array
        if (Array.isArray(input)) {
            input = Uint8Array.from(input);
        }

        if (input instanceof ArrayBuffer) {
            input = new Uint8Array(input);
        }

        // Uint8Array to base64
        if (input instanceof Uint8Array) {
            var str = "";
            var len = input.byteLength;

            for (var i = 0; i < len; i++) {
                str += String.fromCharCode(input[i]);
            }
            input = window.btoa(str);
        }

        if (typeof input !== "string") {
            throw new Error("could not coerce to string");
        }

        // base64 to base64url
        // NOTE: "=" at the end of challenge is optional, strip it off here
        input = input.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");;

        return input;
    }

    export default {
        name: 'loginForm',
        props: ["literals", "autoSso"],
        mixins: [Notification],
        data() {
            return {
                loader: false,
                token: null,
                sso: false,
                twoFactor: false,
                twoFactorRecovery: false,
                secureKey: false,
                secureKeyObj: null,
                reCaptcha: {
                    visibility: false,
                    valid: false,
                    providerResponse: null,
                    siteKey: null,
                },
                form: {
                    valid: true,
                    email: {
                        value: "",
                        error: true,
                        showError: false
                    },
                    password: {
                        value: "",
                        error: true,
                        showError: false
                    },
                    rememberme: {
                        value: false,
                        error: false
                    },
                    autenticationCode: {
                        value: "",
                        error: true,
                        showError: false
                    }
                }
            }
        },
        methods: {
            reCaptchaVerifyCallback(response) {
                this.reCaptcha.providerResponse = response;
                if (response) {
                    this.reCaptcha.valid = true;
                } else {
                    this.reCaptcha.valid = false;
                }
                this.isValid();
            },
            singleValid(field) {

                this.form[field].error = !this.form[field].value;

                if (field == 'email') {
                    this.$refs.emailRequiredValMsg.innerHTML = "";
                    this.$refs.emailRegexValMsg.innerHTML = "";

                    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!this.form.email.value) {
                        this.$refs.emailRequiredValMsg.innerHTML = "The Email field is required.";

                        this.form.email.error = true;
                        this.form.email.errorType = 'required';
                    }
                    else if (!emailRegex.test(this.form.email.value.toLowerCase())) {
                        this.$refs.emailRegexValMsg.innerHTML = "The email address you entered is not valid. Please enter a valid one.";

                        this.form.email.error = true;
                        this.form.email.errorType = 'regex';
                    }
                    this.$refs.email.focus();
                }

                if (field == 'password') {
                    this.$refs.passwordRequiredValMsg.innerHTML = "";

                    if (!this.form.password.value) {
                        this.$refs.passwordRequiredValMsg.innerHTML = "The Password field is required.";

                        this.form.password.error = true;
                        this.form.password.errorType = 'required';

                        if (!this.form.email.error) {
                            this.$refs.password.focus();
                        }
                    }
                }

                this.form[field].showError = this.form[field].error;

                if (field == 'autenticationCode') {
                    this.form.autenticationCode.error = this.twoFactorRecovery ? this.form.autenticationCode.value.length < 24 : this.form.autenticationCode.value.length < 6;
                    this.form.autenticationCode.showError = false;
                }

                this.isValid();

            },
            isValid() {

                if (this.reCaptcha.visibility && !this.reCaptcha.valid) {
                    return this.form.valid = false;
                }

                return this.form.valid = this.twoFactor ? !this.form.autenticationCode.error : !this.form.email.error && !this.form.password.error;
            },
            secureKeySign(SecureKeyDatas) {
              const isLocalDev = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
              if (location.protocol === 'http:' && !isLocalDev) {
                    this.secureKey = false;
                    this.secureKeyObj = null;
                    throw new Error("U2F isn't supported over http, only https");
                }
                if (SecureKeyDatas.UseWebAuthn) {
                    var challenge = coerceToArrayBuffer(SecureKeyDatas.Challenge);
                    var credentialId = coerceToArrayBuffer(SecureKeyDatas.CredentialId);

                    // sample arguments for login
                    var getCredentialDefaultArgs = {
                        publicKey: {
                            timeout: 60000,
                            challenge: challenge,
                            allowCredentials: [{
                                id: credentialId,
                                type: "public-key",
                            }]
                        },
                    };

                    var secureKeyObj = this.secureKeyObj;
                    var login = this.login;

                    navigator.credentials.get(getCredentialDefaultArgs).then((assertion) => {

                        let authData = new Uint8Array(assertion.response.authenticatorData);
                        let clientDataJSON = new Uint8Array(assertion.response.clientDataJSON);
                        let rawId = new Uint8Array(assertion.rawId);
                        let sig = new Uint8Array(assertion.response.signature);

                        var deviceResponse = JSON.stringify({
                            id: assertion.id,
                            rawId: coerceToBase64Url(rawId),
                            type: assertion.type,
                            extensions: assertion.getClientExtensionResults(),
                            response: {
                                authenticatorData: coerceToBase64Url(authData),
                                clientDataJson: coerceToBase64Url(clientDataJSON),
                                signature: coerceToBase64Url(sig)
                            }
                        });
                        SecureKeyDatas.UseWebAuthn = true;
                        SecureKeyDatas.DeviceResponse = deviceResponse;
                        SecureKeyDatas.IsSecureKeyRequest = true;
                        this.secureKeyObj = SecureKeyDatas;
                        this.login();
                    }).catch((err) => {
                        console.log("ERROR", err);
                        this.secureKey = false;
                        this.secureKeyObj = null;
                        this.showNotification({ type: "error", message: "Sign failed. Please check your u2f device." });
                    })
                }
                else {
                    u2f.sign(SecureKeyDatas.AppId, SecureKeyDatas.Challenge, JSON.parse(SecureKeyDatas.RegisteredKeys), (data) => {
                        if (!data.errorCode) {
                            SecureKeyDatas.DeviceResponse = JSON.stringify(data);
                            SecureKeyDatas.IsSecureKeyRequest = true;
                            SecureKeyDatas.UseWebAuthn = false;
                            this.secureKeyObj = SecureKeyDatas;
                            this.login()
                        } else {
                            this.secureKey = false;
                            this.secureKeyObj = null;
                            this.showNotification({ type: "error", message: "Sign failed. Please check your u2f device." });
                        }
                    });
                }
            },
            login(event) {

                if (event) {
                    event.preventDefault();
                }

                const params = {};

                if (this.isValid()) {
                    this.loader = true;

                    params.email = this.form.email.value;
                    params.password = this.form.password.value;
                    params.rememberMe = this.form.rememberme.value;
                    params.RedirectDatas = loginStartModel.RedirectDatas;
                    params.ReCaptchaDatas = {
                        ProviderResponse: this.reCaptcha.providerResponse
                    };
                    params.SSODatas = {
                        IsSSORequest: this.sso
                    };

                    if (this.form.autenticationCode.value) {
                        params.TwoFactorAuthenticationDatas = {
                            signInType: this.form.autenticationCode.value.length == 24 ? 0 : 1,
                            isTwoFactorAuthenticationRequest: true,
                            authenticationCode: this.form.autenticationCode.value
                        }
                    }

                    if (this.secureKey && this.secureKeyObj) {
                        params.SecureKeyDatas = this.secureKeyObj;
                    }

                    Services.post('/account/signin', params, { headers: { 'X-Request-Verification-Token': this.token } })
                        .then(response => {

                            let { Succeeded, RedirectDatas, Errors, TwoFactorAuthenticationDatas, SecureKeyDatas, ReCaptchaDatas } = response.data;

                            if (!Succeeded && Errors.length > 0) {
                                Errors.map((item) => {
                                    setTimeout(() => {
                                        this.showNotification({ type: "error", message: item, closeDelay: 15000 })
                                    }, 100);
                                })
                            }

                            if (TwoFactorAuthenticationDatas.OpenTwoFactorAuthenticationView) {
                                this.twoFactor = true;
                            }

                            if (SecureKeyDatas.OpenSecureKeyView && !SecureKeyDatas.IsSecureKeyRequest) {
                                this.secureKey = true;
                                this.secureKeySign(SecureKeyDatas);
                            }

                            if (ReCaptchaDatas.Visibility) {
                                this.reCaptcha.visibility = true;
                                this.reCaptcha.siteKey = ReCaptchaDatas.SiteKey;
                                if (document.getElementById("reCaptcha").innerHTML == '') {
                                    this.form.valid = false;
                                    grecaptcha.render(document.getElementById("reCaptcha"), {
                                        'sitekey': ReCaptchaDatas.SiteKey,
                                        'callback': this.reCaptchaVerifyCallback,
                                    });
                                }
                            }

                            if (Succeeded && RedirectDatas.Redirect) {
                                location.href = RedirectDatas.RedirectURL;
                                return;
                            }

                            this.loader = false;

                        })
                        .catch((error) => {
                            let messages = error.response ? `${error.response.status} - ${error.response.statusText}` : 'An unknown error has occurred';
                            this.showNotification({ type: "error", message: messages });
                            this.loader = false;
                        })
                } else {
                    this.loader = false;
                    this.singleValid("email");
                    this.singleValid("password");

                    if (this.reCaptcha.visibility && !this.reCaptcha.valid) {
                        this.showNotification({ type: "error", message: "Captcha is not valid" });
                    }
                }
            }
        },
        watch: {
            sso: function (value) {
                this.form.password.value = "";
                this.form.password.error = !value;
                this.$refs.email.focus();
                this.isValid();
            },
            twoFactor: function () {
                this.form.autenticationCode.value = "";
                this.form.autenticationCode.error = true;
                this.isValid();

                this.$nextTick(() => {
                    if (this.twoFactor) {
                        this.$refs.authCode.focus();
                    }
                });
            },
            twoFactorRecovery: function (value) {
                this.form.autenticationCode.value = "";
                this.form.autenticationCode.error = true;
                this.isValid();
            }
        },
        created: function () {
            document.body.classList.remove("login-not-loaded");
            document.body.classList.add("login-loaded");


            this.token = document.querySelector("[name='__RequestVerificationToken']").value;

            if (loginStartModel.Errors.length > 0) {
                loginStartModel.Errors.map((item) => {
                    let _type = "error";
                    if (item === "You have been signed out as you were inactive for too long. Please sign in again.") {
                        _type = "warning";
                    }
                    setTimeout(() => {
                        this.showNotification({
                            type: _type,
                            message: item,
                            offset: 60,
                            multiLine: false,
                            right: false,
                            closeDelay: 10000
                        })
                    }, 100);
                })
            }
        }
    }
</script>
